module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<input type="image" class="'+(props.styles.logoImage)+'" aria-label="'+(props.texts.label)+'" tabindex="0" />';return out;
} 
  };